const TRAIN_BASE_URL = "https://api.kjl.co.tz:8085";
const TRACE_BASE_URL = "https://api.kjl.co.tz:4000";
const EMAIL_BASE_URL = "https://api.kjl.co.tz:8080";

// const TRAIN_BASE_URL = "http://192.168.100.195:8085";
// const TRACE_BASE_URL = "http://192.168.100.195:4000";
// const EMAIL_BASE_URL = "http://192.168.100.195:8080";

export { TRACE_BASE_URL, EMAIL_BASE_URL, TRAIN_BASE_URL };
